import React from 'react';
import { XIcon } from 'lucide-react';
import { failedAttempts } from '../data/content';
export function WhyItFailed() {
  return <section aria-labelledby="fallos-titulo" className="w-full bg-sand-50 py-16 sm:py-24" data-id="element-182" data-mp="a8nwyas4z1d2">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-183" data-mp="p558p348mi05">
        <div data-id="element-184" data-mp="k3po1c5z2dia">
          <h2 id="fallos-titulo" className="font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-185" data-mp="k7dg06vrqruw">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink/65" data-id="element-186" data-mp="17vej30a6hg2x">
            Ninguno de estos métodos es una estafa. Simplemente ninguno ataca la compresión, que es
            la causa física del corrientazo.
          </p>
        </div>

        <ul className="divide-y divide-sand-200" data-id="element-187" data-mp="1gw31e76lu2lm">
          {failedAttempts.map(item => <li key={item.title} className="flex gap-4 py-5 first:pt-0 last:pb-0" data-id="element-188" data-mp="1cvj493m16yzh">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ember-500/10 text-ember-600" data-id="element-189" data-mp="1bkzbtfvk91vx">
                <XIcon aria-hidden="true" className="h-4 w-4" strokeWidth={3} data-id="element-190" data-mp="1fnc6n98rrfdx" />
              </span>
              <div data-id="element-191" data-mp="1kmfc2usnvnmf">
                <h3 className="font-display text-lg font-bold text-ink" data-id="element-192" data-mp="1pjfdutiha47q">{item.title}</h3>
                <p className="mt-1 text-base leading-relaxed text-ink/70" data-id="element-193" data-mp="1ph2t68lc5fqz">{item.body}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}